import { LogicalFieldMixin } from './mixins.js';

const LogicalDateTime = {
  mixins: [LogicalFieldMixin],

  template: `
    <div class="form-field-input">
      <div class="form-field-value input-control right-addon grow-input">
        <div class="controlled-input placeholder">请选择</div>
        <div class="addon large">
          <i :class="settingIcon"></i>
        </div>
      </div>
    </div>
  `,

  computed: {
    settingIcon: function() {
      switch (this.field.settings.input_type) {
        case 'date':
          return 'slp-date';
        case 'time':
          return 'slp-time-circle-o';
        default:
          return 'slp-date-time';
      }
    }
  }
};

export default LogicalDateTime;
